export type WizardVideoSources = {
  mp4: string
  poster: string
}

export type WizardVideoMap = {
  Female: {
    Anime: WizardVideoSources
    Realistic: WizardVideoSources
  }
}

function video(path: string): WizardVideoSources {
  const mp4 = `/create/wizard-previews/${path}`
  return { mp4, poster: mp4.replace(/\.mp4$/, ".poster.jpg") }
}

function pair(section: string, slug: string): WizardVideoMap {
  return {
    Female: {
      Anime: video(`${section}/${slug}/anime.mp4`),
      Realistic: video(`${section}/${slug}/realistic.mp4`),
    },
  }
}

export const STYLE_PREVIEW_VIDEOS = {
  realistic: video("style/realistic.mp4"),
  anime: video("style/anime.mp4"),
} as const

export const ETHNICITY_PREVIEW_VIDEOS = {
  Caucasian: pair("ethnicity", "caucasian"),
  Asian: pair("ethnicity", "asian"),
  Latina: pair("ethnicity", "latina"),
  African: pair("ethnicity", "african"),
  Arab: pair("ethnicity", "arab"),
} as const

export const BODY_TYPE_PREVIEW_VIDEOS = {
  slender: pair("body-type", "slender"),
  muscular: pair("body-type", "muscular"),
  BBW: pair("body-type", "bbw"),
  Curvy: pair("body-type", "curvy"),
} as const

export const BREAST_SIZE_PREVIEW_VIDEOS = {
  petite: pair("breast-size", "petite"),
  Medium: pair("breast-size", "medium"),
  Large: pair("breast-size", "large"),
  Athletic: pair("breast-size", "athletic"),
} as const

export const BUTT_SIZE_PREVIEW_VIDEOS = {
  Small: pair("butt-size", "small"),
  Medium: pair("butt-size", "medium"),
  Large: pair("butt-size", "large"),
  Athletic: pair("butt-size", "athletic"),
} as const
